/** Only same-app paths; never an absolute URL or a protocol-relative one (open-redirect guard). */
export function safeReturnTo(value, fallback = '/') {
    if (!value || !value.startsWith('/'))
        return fallback;
    // `//host` and `/\host` are both treated as protocol-relative by browsers.
    const second = value.charAt(1);
    if (second === '/' || second === '\\')
        return fallback;
    return value;
}
//# sourceMappingURL=return-to.js.map